module.exports = __webpack_public_path__ + "static/black1_v2-82b280228496e9d3da61630a153a4212.png";